import { useContext } from "react";
import { WebinarContext } from "../providers/WebinarProvider";

export default function useWebinar() {
  const context = useContext(WebinarContext);

  if (context === undefined) {
    throw new Error("useWebinar must be used within a WebinarProvider");
  }
  return context;
}
